module.exports = "/ui/fb5e0252c1411b546ddbb6eda9926cc2.png";